import { globalApi as api } from '../../api';

export const createRole = async (AddRole) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/role', AddRole, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response) {
      console.log("Error Response", error.response.data);
      return error.response.data
    } else {
      console.error("Error Message", error.message);
      return error.message
    }
  }
};


export const fetchRole = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const use_company_code = JSON.parse(sessionStorage.getItem('user'));
    const response = await api.get(`/roles/${use_company_code.company_code}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const fetchRolecompany = async (CompanyID) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await api.get(`/roles/${CompanyID}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data.error : error.message;
    }
  };
export const updateRole = async (id, updateRoleData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/role/${id}`, updateRoleData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deleteRole = async (id) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await api.delete(`/role/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data.error : error.message;
    }
  };
  export const getUserRole = async (id) => {
    try {
        // alert(id);
    const use_company_code = JSON.parse(sessionStorage.getItem('user'));
      const token = sessionStorage.getItem('token');
      const response = await api.get(`/role/${id}`, {params: {
        company_code: use_company_code.company_code
      },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data.error : error.message;
    }
  };

